import LacunaWebPKI from 'web-pki';

// Licença do WebPKI - centralizada em um único lugar
const WEBPKI_LICENSE = 'AhkAbGl2ZS5jaGFuY2VsYWZhY2lsLmNvbS5ichwAc2FuZGJveC5jaGFuY2VsYWZhY2lsLmNvbS5icggAU3RhbmRhcmQIAACYMLNPiN8IAAEtzWe9h9mdZPWAY8dAKHNMw9NUrWB27gn0Xl5tM9qBK1opCCn85M0xih4pNYaQLIkL5xs6/bo59X7IJkakVZKGxI3b5IEKoBE4auWUI1hgAyX6EUlHMmf+8N0TfzLgyvVSkTk392xkZPH4W4NFm//P4KSPKIFtOa3ul52LeqWCVDXOWn4ox6FIinUqFcxsIzcRf6y/JqY87JAxdZIMSnDl/Sq+iwGjEJOPBW02XbT4V3sPz7I9BpzTD3P4OMPFlMfj8tfmqgBWs2WP0Eimb9XmZfPRewhGCqZzNq4XaAJiIayw1ghGPsNS6BjdsP2oegpALcusJ2zhi/169gte3Qqa';

/**
 * Cria e retorna uma instância configurada do LacunaWebPKI com a licença
 * @returns {LacunaWebPKI} Instância configurada do WebPKI
 */
export const createWebPKI = () => {
  return new LacunaWebPKI(WEBPKI_LICENSE);
};

/** OID ou nome retornado pela API → nome aceito pelo Lacuna Web PKI em signHash.digestAlgorithm */
export function digestAlgForWebPki(algFromApi) {
  if (!algFromApi) return 'SHA-256';
  const raw = String(algFromApi).trim();
  if (raw.includes('.')) {
    const oidMap = {
      '2.16.840.1.101.3.4.2.1': 'SHA-256',
      '2.16.840.1.101.3.4.2.2': 'SHA-384',
      '2.16.840.1.101.3.4.2.3': 'SHA-512',
      '1.3.14.3.2.26': 'SHA-1',
      '1.2.840.113549.2.5': 'MD5',
    };
    return oidMap[raw] || 'SHA-256';
  }
  const upper = raw.toUpperCase().replace(/_/g, '-');
  const known = ['SHA-256', 'SHA-384', 'SHA-512', 'SHA-1', 'MD5'];
  return known.includes(upper) ? upper : 'SHA-256';
}

// Exportar a licença caso seja necessário em algum lugar específico
export { WEBPKI_LICENSE };
